import React from 'react';
import styled from 'styled-components';
import logo from '../../assets/Logo.png';
import { MdOutlineMail } from 'react-icons/md';
import { navigationItems, contactInfo } from '../../config/navigation';

const FooterContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 2rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    flex-direction: row;
    gap: 1rem;
    justify-content: center;
  }
`;

const LogoContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: 100%;
  }
`;

const NavContainer = styled.div`
  display: flex;
  gap: 3rem;
  flex: 6;
  justify-content: center;
  align-items: center;
  padding-top: 0.5rem; // Add padding to align with "Contact us" text

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    justify-content: center;
  }
`;

const NavLinksWrapper = styled.div`
  display: flex;
  gap: 3rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    flex-direction: column;
    gap: 1rem;
  }
`;

const ContactContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  padding-top: 0.5rem; // Add padding to align with nav items

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: 100%;
  }
`;

const ContactTitle = styled.div`
  color: #264980;
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  line-height: 1; // Add line-height to match nav items

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 14px;
  }
`;

const EmailLink = styled.a`
  color: #264980;
  mix-blend-mode: normal;
  text-decoration: none;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 14px;
    gap: 0.25rem;
  }
`;

const FooterContainer = styled.footer`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 2rem 5rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 1rem;
  }
`;

const Logo = styled.img`
  height: 50px;
`;

const NavLink = styled.a`
  color: #264980;
  mix-blend-mode: normal;
  text-decoration: none;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1; // Add line-height to match contact title

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 0.75rem;
  }
`;

const Divider = styled.hr`
  border: none;
  border-top: 1px solid #e5e7eb;
  margin: 2rem 0;
`;

const Copyright = styled.p`
  color: grey;
  font-size: 0.9rem;
  text-align: center;
  margin: 0;
`;

const getCopyrightYear = () => {
  const currentYear = new Date().getFullYear();
  return currentYear === 2025 ? '2025' : `2025-${currentYear}`;
};

export const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <LogoContainer>
          <Logo src={logo} alt="MoneyQube Logo" />
        </LogoContainer>
        <NavContainer>
          <NavLinksWrapper>
            {navigationItems.map((item) => (
              <NavLink key={item.href} href={item.href}>
                {item.label}
              </NavLink>
            ))}
          </NavLinksWrapper>
        </NavContainer>
        <ContactContainer>
          <ContactTitle>Contact us</ContactTitle>
          <EmailLink href={`mailto:${contactInfo.email}`}>
            <MdOutlineMail />
            {contactInfo.email}
          </EmailLink>
        </ContactContainer>
      </FooterContent>
      <Divider />
      <Copyright>© {getCopyrightYear()} MoneyQube. All Rights Reserved.</Copyright>
      <Copyright>MoneyQube MF Distributors LLP is a AMFI Registered Mutual Fund Distributor (ARN-335143)</Copyright>
    </FooterContainer>
  );
};
